import Conclusion from './Conclusion';

export default Conclusion;
